import React from "react";
import PublicNavbar from "../../components/public/PublicNavbar";

const WarrantyPolicy = () => {
    return (
        <div className="min-h-screen bg-[#FFFFFF] text-[#263746] font-sans">
            <PublicNavbar />

            <div className="bg-[#F7F5EF] border-b border-[#E5E7EB] py-12 px-6 text-center">
                <div className="max-w-4xl mx-auto">
                    <span className="text-[#E3B629] text-xs font-black tracking-[0.25em] uppercase block mb-1">
                        Equipment Assurance
                    </span>
                    <h1 className="text-3xl sm:text-4xl font-extrabold text-[#263746]">
                        Warranty Policy & Technical Service
                    </h1>
                    <p className="text-[#687482] text-xs sm:text-sm mt-2">
                        LUMIGO PROJECTION SOLUTIONS • Fourlifters Private Limited • Commercial Gobo Projector Coverage
                    </p>
                </div>
            </div>

            <div className="max-w-4xl mx-auto px-6 py-12 space-y-8 text-[#687482] text-xs sm:text-sm leading-relaxed">
                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        1. Commercial Warranty Coverage
                    </h2>
                    <p>
                        LUMIGO warrants that commercial gobo projectors supplied by Fourlifters Private Limited under accepted commercial quotations will be free from defects in materials and manufacturing workmanship under normal commercial installation and operating conditions.
                    </p>
                    <p>
                        Specific warranty terms (typically 1 to 2 years on the OSRAM LED source and internal electronic constant-current LED driver) are stated in the written commercial invoice issued at order confirmation.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        2. Scope of Warranty Coverage
                    </h2>
                    <ul className="list-disc list-inside space-y-1 text-[#687482]">
                        <li>Premature failure of the solid-state OSRAM LED light engine.</li>
                        <li>Internal electronic power supply / driver failure under normal rated voltage (90–220V, 50/60Hz).</li>
                        <li>Internal motorized rotation drive gear failure on dynamic rotation models.</li>
                    </ul>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        3. Warranty Exclusions
                    </h2>
                    <p>Warranty coverage does not apply to:</p>
                    <ul className="list-disc list-inside space-y-1 text-[#687482]">
                        <li>Physical glass scratches, drops, impacts, or lens breakage caused by improper mounting or handling.</li>
                        <li>Damage resulting from severe electrical surges, lightning strikes, or operating outside rated voltage without voltage stabilization.</li>
                        <li>Submersion in water or usage of indoor (IP20) units in outdoor unsheltered conditions.</li>
                        <li>Unauthorized disassembly, modification of the optical housing, or tampering with electrical wiring.</li>
                    </ul>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        4. Raising a Warranty Claim
                    </h2>
                    <p>
                        To initiate technical support or a warranty evaluation, provide your quotation reference or invoice copy along with photos and video of the operating anomaly:
                    </p>
                    <p className="font-semibold text-xs text-[#263746] leading-relaxed">
                        Fourlifters Private Limited (Brand: LUMIGO)<br />
                        E-21/22, Kaygee Engineering Premises, T Block, MIDC Bhosari, Pune, Maharashtra - 411026<br />
                        Email: fourlifters@gmail.com / sales@fourlifters.in | WhatsApp Technical Desk: +91 8087680893
                    </p>
                </section>
            </div>
        </div>
    );
};

export default WarrantyPolicy;
